import React from 'react';
import Table from '../../CustomTable';

import { Button } from 'react-bootstrap';
import { isEmptyObject } from '../../../../helpers/helpers';
import { PracticeTable } from '../types';

export default ({ editingIndex, practiceFields, handleEditClick, handleDeleteClick } : PracticeTable) => {

  const lastHeaderStyle = Object.keys(practiceFields).length > 3 ?
    { width: '100px', minWidth: '100px', maxWidth: '100px' } : { width: '99px', minWidth: '99px', maxWidth: '99px' };
  const lastColumnStyle = Object.keys(practiceFields).length > 3 ?
    { width: '96px', minWidth: '96px', maxWidth: '96px' } : { width: '99px', minWidth: '99px', maxWidth: '99px' };
  const headers = [
    { content: 'NAME', class: 'l-ll t-ll', style: { width: '257px', minWidth: '257px', maxWidth: '257px' } }, /* 130 + 127 */
    /*{ content: 'IMAGE FILE', class: 't-ll', style: { width: '127px' } }, */
    { content: 'X0', class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
    { content: 'Y0', class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
    { content: 'X1', class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
    { content: 'Y1', class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
    { content: 'TYPE', class: 't-ll', style: { width: '70px', minWidth: '70px', maxWidth: '70px' } },
    { content: 'WIDTH FT', class: 't-ll', style: { width: '130px', minWidth: '130px', maxWidth: '130px' } },
    { content: 'HEIGHT FT', style: { width: '130px', minWidth: '130px', maxWidth: '130px' } },
    { class: 't-ll', style: lastHeaderStyle }
  ];

  let rows: any = []; // review with Gauss
  if (!isEmptyObject(practiceFields)) {
    rows = Object.entries(practiceFields).map(([key, field]) => {

      return ({
        columns: [
          { content: field.areaName, class: 'l-ll t-ll', style: { width: '257px', minWidth: '257px', maxWidth: '257px' } },
          { content: field.x0 || 0, class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
          { content: field.y0 || 0, class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
          { content: field.x1 || 0, class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
          { content: field.y1 || 0, class: 't-ll', style: { width: '80px', minWidth: '80px', maxWidth: '80px' } },
          { content: field.type === 'indoor' ? 'In' : 'Out', class: 't-ll', style: { width: '70px', minWidth: '70px', maxWidth: '70px' } },
          { content: field.widthFt, class: 't-ll', style: { width: '130px', minWidth: '130px', maxWidth: '130px' } },
          { content: field.heightFt, style: { width: '130px', minWidth: '130px', maxWidth: '130px' } },
          {
            class: 't-ll',
            style: lastColumnStyle,
            print: (content: string) => (
              <>
                <label style={{ marginTop: '6px' }}>{content}</label>
                {editingIndex === key ?
                  <button className="trash-00" onClick={() => handleDeleteClick(key)}>
                    <img src="/assets/trash.svg" alt="" height="20px" />
                  </button> :
                  <Button
                    className="btn-blue"
                    style={{ maxWidth: '53px' }}
                    onClick={() => handleEditClick(key)}
                  >
                    Edit</Button>
                }
              </>
            )
          }
        ],
        id: key
      });
    });
  };

  return (
    <Table
      classTable={'table-with-borders pa-maps-table'}
      headers={headers}
      rows={rows}
      isSelectedStyle
    />
  );
};
